var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormViewTemplate',{attrs:{"backButtonRoute":'/settings/company',"dataModel":_vm.model,"toolbarOptions":_vm.toolbarOptions,"formItems":_vm.setFormItems,"saveModel":_vm.saveModel,"pageData":_vm.pageData}})
}
var staticRenderFns = []

export { render, staticRenderFns }